import { I2iRecom, I2iRecomResultsItems, Item2ItemRecommendationsApi } from '../../../api/recommendation-service';
import { IRecommendationService } from '../interfaces/recommendation-service.interface';

class RecommendationService implements IRecommendationService {
    private api: Item2ItemRecommendationsApi;

    constructor() {
        this.api = new Item2ItemRecommendationsApi();
    }

    public async getRecommendedSkus(
        sku: string,
        customerNumber: string,
        numberOfRecommendations: number = 10,
        customerThemeType: number = null
    ): Promise<Array<string>> {
        const recommendations: I2iRecom = await this.api.i2iV1Get(
            sku,
            customerNumber,
            numberOfRecommendations,
            0,
            customerThemeType,
        );

        return recommendations.results.items.map(
            (resultsItems: I2iRecomResultsItems) => { return resultsItems.id; }
        );
    }
}

export const recommendationService: RecommendationService = new RecommendationService();
